import './local.scss';
import Error from '../../components/Error';

const NftError = () => {
  return <Error message="Something went wrong. We couldn't assign a new role for you." />;
};

export default NftError;
